import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { AssetInventoryService } from '../../services/asset-inventory.service';
import { AssetService } from '../../services/asset-service';
import { AssetInventory } from '../../models/entities/asset-inventory';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';

@Component({
    selector: 'asset-inventory-widget-mobile',
    templateUrl: './asset-inventory-widget-mobile.component.html',
    styleUrls: ['./asset-inventory-widget-mobile.component.scss']
})

export class AssetInventoryWidgetMobileComponent implements OnInit {


  barCode       : string;
  barCodes      : string[] = [];


  currentAssetInventory : AssetInventory;

  constructor(
    protected assetInventoryService: AssetInventoryService,
    protected assetService        : AssetService,
    protected toastr              : ToastrService,
    protected router              : Router,
    protected activatedRoute      : ActivatedRoute,
    public    leanUtilsService    : LeanUtilsService,
    protected location            : Location) {
  }


  ngOnInit(){
    this.assetInventoryService.getCurrentAssetInventory().then(result => {
      this.currentAssetInventory = result;
      if (! this.currentAssetInventory.assetInventoryCode) {
        this.toastr.error("Pas d'inventaire ouvert pour ce dépôt");
      }
    })
  }

  returnBack(){
    this.location.back();
  }

  addBarCode(){
    if (! this.barCode){
      this.toastr.error("Prière de scanner un code à barres");
      return;
    }

    this.barCode = this.barCode.trim()
    if (this.barCode == ""){
      this.toastr.error("Prière de scanner un code à barres");
      return;
    }
  
    
    if ( (this.leanUtilsService.barCodelength) && (this.barCode.length != this.leanUtilsService.barCodelength) ) {
      this.toastr.error("Longueur du code à barres invalide");
      return;
    }
    
  
    for (let b of this.barCodes) {
        if (b == this.barCode) {
          this.toastr.error("Ce code à barres est déjà affecté à ce transfert");
          return;
        }
    }

    this.barCodes.push(this.barCode);
  }


  
  remove(barCode : string){
    const index = this.barCodes.indexOf(barCode, 0);
    if (index > -1) {
      this.barCodes.splice(index, 1);
    }
  }


 
  save(){
    this.assetInventoryService.assetInventoryRegister(this.barCodes).then(result => {
        this.toastr.success("Opération effectuée avec succès");
    })
  } 

}

